export const TWITTER_LOGIN = "TWITTER_LOGIN"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"

export const LOGOUT_USER = "LOGOUT_USER"
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS"

export const LOGIN_FAIL = "LOGIN_FAIL"
export const LOGIN_PROCESSING = "LOGIN_PROCESSING"
